import React from "react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import { observer } from "mobx-react";
import "./SchoolDashboard.css"
import { FaUsers } from "react-icons/fa";
import { Button, DatePicker, Empty, Image, Modal, Spin, Table } from "antd";
import StudentsBorded from "../assets/images/SchoolDashboard/StudentsBorded.svg"
import StudentsOffBorded from "../assets/images/SchoolDashboard/StudentsOffBorded.svg"
import TotalTrips from "../assets/images/SchoolDashboard/TotalTrips.svg"
import CriticalAlerts from "../assets/images/SchoolDashboard/CriticalAlerts.svg"
import { Area, AreaChart, Line, ReferenceLine, ResponsiveContainer, XAxis, YAxis, Tooltip, PieChart, Pie, Cell } from "recharts";
import LiveTrackingMap from "./LiveTrackingMap";
import SchoolDashboardStore from "../store/SchoolDashboardStore";
import LiveTrackingStore from "../store/LiveTrackingStore";
import maplibregl from "maplibre-gl";
const data = [
    { day: "1", speed: 20 },
    { day: "2", speed: 30 },
    { day: "3", speed: 45 },
    { day: "4", speed: 50 },
    { day: "5", speed: 40 },
    { day: "6", speed: 91 }, // peak point
    { day: "7", speed: 35 },
    { day: "8", speed: 50 },
    { day: "9", speed: 60 },
    { day: "10", speed: 25 },
    { day: "11", speed: 70 },
    { day: "12", speed: 55 },
    { day: "13", speed: 65 },
    { day: "14", speed: 50 }
];
const data1 = [
    { name: "Students Onboard", value: 57, color: "#f4b04f" },
    { name: "Students Offboarded", value: 23, color: "#6bd3a3" },
    { name: "Students Absent", value: 14, color: "#4c6edb" },
    { name: "Students Absent 2", value: 6, color: "#ff6b6b" }
];

const COLORS = ["#f4b04f", "#6bd3a3", "#4c6edb", "#ff6b6b"];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
    cx, cy, midAngle, innerRadius, outerRadius, percent
}) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return percent > 0.1 ? ( // show only bigger slices
        <text x={x} y={y} fill="#fff" textAnchor="middle" dominantBaseline="central" fontSize={10}>
            {(percent * 100).toFixed(0)}%
        </text>
    ) : null;
};

const alerts = [
    { id: 1, title: 'Bus Running Late', desc: 'Bus No. 458 running late by 10 minutes', time: '2 hours ago', status: 'late', type: 'late' },
    { id: 2, title: 'AD4568 - Completed Trip', desc: 'at the palm jummarih hotel', time: '3 hours ago', status: 'Completed', type: 'completed' },
    { id: 3, title: 'Bus Running Late', desc: 'Bus No. 458 running late by 10 minutes', time: '2 hours ago', status: 'late', type: 'late' },
    { id: 4, title: 'AD4568 - Completed Trip', desc: 'at the palm jummarih hotel', time: '3 hours ago', status: 'Completed', type: 'completed' },
    // ... add more items
];


class SchoolDashboard extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            openStudentsBoardedPopup: false,
            openStudentsoffBoardedPopup: false,
            mapType: "carto",
            loadData: 0,
            statusType: "",
            dailyStatus: 1,
            open: false,
            dateString: '',
            isSchoolDashboard: true,
            loading: false,
        }

        this.datePickerRef = React.createRef();
        this.schoolDashboardStore = new SchoolDashboardStore(this)
        this.liveTrackingStore = new LiveTrackingStore(this)

        this.schoolDashboardColumns = [
            {
                title: context.translate("_BUSNO_"),
                dataIndex: "vehicleNo",
                width: 80,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
                dataIndex: "driverName",
                width: 80,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_"),
                dataIndex: "location",
                width: 80,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_CURRENT_TRIP_"),
                dataIndex: "currentTrip",
                width: 80,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
                dataIndex: "tripStatus",
                width: 80,
                ellipsis: {
                    showTitle: true,
                },
            },
        ]


        this.studentBoardedColumns = [
            {
                title: context.translate("_STUDENT_NAME_"),
                dataIndex: "studentName",
                width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_BUSNO_"),
                dataIndex: "vehicleNo",
                width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_FLEET_DRIVER_DRIVERLIST_DRIVERNAME_"),
                dataIndex: "driverName",
                width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_TAG_ID_"),
                dataIndex: "tagId",
                width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_PICKUP_TIME_"),
                dataIndex: "spInTime",
                width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_PICKUP_LOCATION_"),
                dataIndex: "spInLocation",
                width: 80,
                ellipsis: {
                    showTitle: true,
                },
            },
        ]

        this.studentOffBoardedColumns = [
            {
                title: context.translate("_STUDENT_NAME_"),
                dataIndex: "studentName",
                width: 60,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_BUSNO_"),
                dataIndex: "vehicleNo",
                width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_FLEET_DRIVER_DRIVERLIST_DRIVERNAME_"),
                dataIndex: "driverName",
                width: 60,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_TAG_ID_"),
                dataIndex: "tagId",
                width: 40,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_PICKUP_TIME_"),
                dataIndex: "spInTime",
                width: 65,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_PICKUP_LOCATION_"),
                dataIndex: "spInLocation",
                width: 80,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_DROP_TIME_"),
                dataIndex: "spOutTime",
                width: 65,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_DROP_LOCATION_"),
                dataIndex: "spOutLocation",
                width: 80,
                ellipsis: {
                    showTitle: true,
                },
            },
        ]
    }

    CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{
                    background: "#3b82f6",
                    color: "#fff",
                    padding: "6px 10px",
                    borderRadius: "6px"
                }}>
                    {payload[0].value} kmph
                </div>
            );
        }
        return null;
    };

    async componentDidMount() {
        await this.schoolDashboardStore.getDashboardCount(
            this.props.getUserData().userCompanyId
        )

        await this.schoolDashboardStore.getDashboardData(
            this.props.getUserData().userCompanyId
        )

        await this.schoolDashboardStore.getPieChartData(
            {
                companyId: this.props.getUserData().userCompanyId,
                dailyStatus: this.state.dailyStatus
            }
        )

        await this.schoolDashboardStore.getMaxSpeedData({
            companyId: this.props.getUserData().userCompanyId,
            isadmin: this.props.getUserData().isadmin,
        })

        await this.liveTrackingStore.getAllVehicles(this.props.getUserData().userCompanyId,)

        await this.schoolDashboardStore.getAlertsData(this.props.getUserData().userCompanyId)

        const allVehicles = this.liveTrackingStore?.plotAllVehicles || [];

        const map = this.mapRef;

        // fit bounds
        if (map) {
            const bounds = new maplibregl.LngLatBounds();
            allVehicles.forEach((v) => {
                if (v.latitude != null && v.longitude != null) {
                    bounds.extend([v.longitude, v.latitude]);
                }
            });

            if (!bounds.isEmpty()) {
                map.fitBounds(bounds, { padding: 60, duration: 800 });
            }
        }
        this.setState({ loadData: 1 })
    }

    openPicker = () => {
        this.setState({ open: true });
        // this.datePickerRef.current?.focus(); // open calendar
    };

    loadSearchVehicleIcon = async () => {
        const vehicleData = []


        const uniqueImages = [...new Set(vehicleData.map((v) => v.mapImage))];

        const imagePromises = uniqueImages.map((imgName) => {
            return new Promise((resolve) => {
                const url = `/vehicle-icons/${imgName}`; // Absolute path to your public folder

                this.mapRef.loadImage(url, (error, image) => {
                    if (!error && image && !this.mapRef.hasImage(imgName)) {
                        this.mapRef.addImage(imgName, image);
                    }
                    resolve();
                });
            });
        });

        await Promise.all(imagePromises);
    };

    render() {
        return (
            <>
                <div className="schoolDashboard">
                    <div className="dashboardCards">
                        <div className="active-buses-card dark">
                            <div className="card-top">
                                <h4>Active Buses</h4>
                                <div className="icon-box">
                                    <img src={require("../assets/images/SchoolDashboard/ActiveBuses.png")} />
                                </div>
                            </div>

                            <h2>{this.schoolDashboardStore.vehicleCount || 0}</h2>
                        </div>

                        <div className="student-dash-card" onClick={async () => {
                            this.setState({ openStudentsBoardedPopup: true, statusType: "onboard" })
                            await this.schoolDashboardStore.getDashboardListData(
                                { companyId: this.props.getUserData().userCompanyId, statusType: "onboard" }
                            )
                            await this.setState({ loadData: 1 })
                        }}>
                            <div className="card-top">
                                <h4>Students Boarded</h4>
                                <div className="icon-box">
                                    <img src={StudentsBorded} />
                                </div>
                            </div>

                            <h2>{this.schoolDashboardStore.studentStatusCount?.onboardCount || 0}</h2>

                        </div>


                        <div className="student-dash-card" onClick={async () => {
                            this.setState({ openStudentsoffBoardedPopup: true, statusType: "offboard" })
                            await this.schoolDashboardStore.getDashboardListData(
                                { companyId: this.props.getUserData().userCompanyId, statusType: "offboard" }
                            )
                            await this.setState({ loadData: 1 })
                        }}>
                            <div className="card-top">
                                <h4>Students Off Boarded</h4>
                                <div className="icon-box">
                                    <img src={StudentsOffBorded} />
                                </div>
                            </div>

                            <h2>{this.schoolDashboardStore.studentStatusCount?.offboardCount || 0}</h2>
                        </div>


                        <div className="student-dash-card">
                            <div className="card-top">
                                <div>
                                    <h4>Total Trips</h4>
                                    <div className="total-trips-count">
                                        <div className="trip-block">
                                            <span>Ongoing Trips</span>
                                            <div className="count-row">
                                                <h2>{this.schoolDashboardStore.tripsCount?.ongoingTrips || 0}</h2>
                                                <span className="fill-ongoing-trips"></span>
                                            </div>
                                        </div>

                                        <div className="trip-block">
                                            <span>Finished Trips</span>
                                            <div className="count-row">
                                                <h2>{this.schoolDashboardStore.tripsCount?.finishTrips || 0}</h2>
                                                <span className="fill-current-trips"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-box">
                                    <img src={TotalTrips} />
                                </div>
                            </div>


                        </div>

                        <div className="student-dash-card">
                            <div className="card-top">
                                <h4>Critical Alerts</h4>
                                <div className="icon-box">
                                    <img src={CriticalAlerts} />
                                </div>
                            </div>

                            <div className="count-row">
                                <h2>0</h2>
                                <span className="fill-alert"></span>
                            </div>

                        </div>

                    </div>

                    {/* Main Content */}
                    <div className="main-grid">

                        {/* Map */}
                        <div className="map-container">
                            {/* <iframe
                            title="map"
                            src="https://maps.google.com/maps?q=Abu%20Dhabi&t=&z=11&ie=UTF8&iwloc=&output=embed"
                        /> */}

                            <LiveTrackingMap
                                liveTrackingMapRef={this.liveTrackingMapRef}
                                mapType={this.state.mapType}
                                vehicles={this.liveTrackingStore?.plotAllVehicles}
                                onMapLoad={(map) => {
                                    this.mapRef = map; // MapLibre instance
                                }}
                                // onVehicleClick={(vehicle) =>
                                //     // this.setState({ vehicleOtherInfo: vehicle })
                                //     this.setState(
                                //         {
                                //             vehicleOtherInfo: null,
                                //         },
                                //         () => {
                                //             // this.setState({
                                //             //   vehicleOtherInfo: vehicle,
                                //             // });
                                //             this.setState(
                                //                 {
                                //                     selectedVehicleId: vehicle.vehicleId,
                                //                     vehicleOtherInfo: vehicle, // immediate data
                                //                 },
                                //                 () => {
                                //                     this.getVehicleOtherInfo(vehicle.vehicleId);
                                //                 }
                                //             );
                                //         }
                                //     )
                                // }
                                loadSearchVehicleIcon={this.loadSearchVehicleIcon}
                                isPlottingVehicles={false}
                                isSchoolDashboard={this.state.isSchoolDashboard}
                            />
                        </div>

                        {/* Chart */}
                        <div className="chart-container">
                            <div className="graph-topbar">
                                <h4>Daily Status</h4>

                                <div className="btnRow">
                                    <Button onClick={async () => {
                                        await this.schoolDashboardStore.getPieChartData(
                                            {
                                                companyId: this.props.getUserData().userCompanyId,
                                                dailyStatus: 1
                                            }
                                        )
                                        this.setState({ dailyStatus: 1, loadData: 1 })

                                    }}>Day</Button>
                                    <Button onClick={async () => {
                                        await this.schoolDashboardStore.getPieChartData(
                                            {
                                                companyId: this.props.getUserData().userCompanyId,
                                                dailyStatus: 2
                                            }
                                        )
                                        this.setState({ dailyStatus: 2, loadData: 1 })

                                    }}>Week</Button>
                                    <Button onClick={async () => {

                                        await this.schoolDashboardStore.getPieChartData(
                                            {
                                                companyId: this.props.getUserData().userCompanyId,
                                                dailyStatus: 3
                                            }
                                        )
                                        this.setState({ dailyStatus: 3, loadData: 1 })
                                    }}>Month</Button>
                                    <a className="calBtn" ><i class="bi bi-calendar4-week" onClick={this.openPicker}></i></a>
                                    <DatePicker
                                        open={this.state.open}
                                        onOpenChange={(open) => this.setState({ open })}
                                        style={{ position: "absolute", opacity: 0 }}
                                        onChange={async (date, dateString) => {

                                            await this.schoolDashboardStore.getPieChartData(
                                                {
                                                    companyId: this.props.getUserData().userCompanyId,
                                                    selectedDate: dateString
                                                }
                                            )
                                            this.setState({ dateString: dateString, loadData: 1 })

                                        }}
                                    />

                                </div>
                            </div>
                            <div className="chart-placeholder">
                                <ResponsiveContainer>
                                    {this.schoolDashboardStore.noData === true ?
                                        <div
                                            style={{
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "16px",
                                                fontWeight: "700"
                                            }}
                                        >No Data</div> :
                                        <PieChart>

                                            {/* Center Text */}
                                            <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fontSize={16} fontWeight="600">
                                                Daily
                                            </text>
                                            <text x="50%" y="58%" textAnchor="middle" dominantBaseline="middle" fontSize={16} fontWeight="600">
                                                Status
                                            </text>

                                            <Pie
                                                data={this.schoolDashboardStore.pieChartData}
                                                // data={data1}
                                                innerRadius={70}   // donut hole
                                                outerRadius={100}
                                                paddingAngle={2}
                                                dataKey="value"
                                                label={renderCustomizedLabel}
                                                labelLine={false}
                                            >
                                                {data.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />

                                                ))}
                                            </Pie>

                                        </PieChart>}
                                </ResponsiveContainer>
                            </div>
                            <div className="pie-chart-grid">
                                <div className="info-item">
                                    <div className="label-group">
                                        <span className="dot-blue"></span>
                                        <span className="label">Students Absent</span>
                                    </div>
                                    <span className="value">{this.schoolDashboardStore.pieChartData[2]?.value || 0}%</span>
                                </div>

                                <div className="info-item">
                                    <div className="label-group">
                                        <span className="dot-orange"></span>
                                        <span className="label">Students Onboard</span>
                                    </div>
                                    <span className="value">{this.schoolDashboardStore.pieChartData[0]?.value || 0}%</span>
                                </div>

                                <div className="info-item">
                                    <div className="label-group">
                                        <span className="dot-green"></span>
                                        <span className="label">Students Offboarded</span>
                                    </div>
                                    <span className="value">{this.schoolDashboardStore.pieChartData[1]?.value || 0}%</span>
                                </div>

                                {/* <div className="info-item">
                                <div className="label-group">
                                    <span className="dot-red"></span>
                                    <span className="label">Students Onboard</span>
                                </div>
                                <span className="value">6%</span>
                            </div> */}
                            </div>
                        </div>

                    </div>

                    {/* Bottom Section */}
                    <div className="bottom-grid">
                        <div className="graph">
                            <h4>Max Speed Graph</h4>
                            <div className="graph-placeholder">
                                <ResponsiveContainer>
                                    {this.schoolDashboardStore.maxSpeedData?.length > 0 ?
                                        <AreaChart data={this.schoolDashboardStore.maxSpeedData}>
                                            <defs>
                                                <linearGradient id="colorSpeed" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.4} />
                                                    <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
                                                </linearGradient>
                                            </defs>
                                            <XAxis dataKey="vehicleNo" />
                                            <YAxis dataKey="maxSpeed" />

                                            <Tooltip content={this.CustomTooltip} />

                                            <Area
                                                type="monotone"
                                                dataKey="maxSpeed"
                                                stroke="none"
                                                fill="url(#colorSpeed)"
                                            />

                                            <Line
                                                type="monotone"
                                                dataKey="maxSpeed"
                                                stroke="#4379EE"
                                            />
                                        </AreaChart>
                                        : <p style={{ textAlign: "center", marginTop: "20px", alignItems: "center", fontWeight: 500 }}>No Data</p>}
                                </ResponsiveContainer>
                            </div>
                        </div>

                        <div className="alerts">
                            {/* <h4>Recent Alerts</h4> */}

                            {/* <div className="alert-container"> */}
                            <div>
                                <h2 className="alert-title">Recent Alerts</h2>

                                <div style={{ maxHeight: "350px", overflowY: "auto" }}>
                                    {this.schoolDashboardStore.alertsData?.length > 0 ? (
                                        this.schoolDashboardStore.alertsData.map((alert) => (
                                            <div key={alert.id} className="alert-item">

                                                <div className={`alert-icon-box ${alert.type}`}>
                                                    <img
                                                        style={{ height: "30px", width: "30px" }}
                                                        src={require("../assets/images/SchoolDashboard/alert-icon.png")}
                                                    />
                                                </div>

                                                <div className="alert-content">
                                                    <div className="alert-header">{alert.ruleName}</div>
                                                    <div className="alert-desc">Bus No.{alert.vehicleNo}</div>
                                                </div>

                                            </div>
                                        ))
                                    ) : (
                                        <p style={{ textAlign: "center", marginTop: "20px", alignItems: "center", fontWeight: 500 }}>No Data</p>
                                    )}
                                </div>
                                {/* {alerts.map((alert) => (
                                <div key={alert.id} className="alert-item">
                                   
                                    <div className={`alert-icon-box ${alert.type}`}>

                                        {alert.type === "late"
                                            ? <img style={{ height: "30px", width: "30px" }} src={require("../assets/images/SchoolDashboard/alert-icon.png")} />
                                            : <img style={{ height: "30px", width: "30px" }} src={require("../assets/images/SchoolDashboard/alert-bus-icon.png")} />}
                                        
                                    </div>

                                   
                                    <div className="alert-content">
                                        <div className="alert-header">{alert.title}</div>
                                        <div className="alert-desc">{alert.desc}</div>
                                    </div>

                                   
                                    <div className="alert-meta">
                                        <div className="alert-time">{alert.time}</div>
                                        <div className={`alert-status ${alert.type}`}>{alert.status}</div>
                                    </div>
                                </div>
                            ))} */}
                            </div>
                        </div>

                    </div>

                    <div style={{ marginBlockStart: "10px", marginBlockEnd: "14px", }}>
                        <Table className="schoolDashboardTable"
                            columns={this.schoolDashboardColumns}
                            dataSource={this.schoolDashboardStore.studentsData}
                            pagination={false}
                            scroll={{ y: 150 }}
                        />
                    </div>

                </div>

                <Modal className="windowModal"
                    open={this.state.openStudentsBoardedPopup}
                    footer={null}
                    closable={false}
                    width={1100}
                    maskClosable={true}
                    onCancel={() => this.setState({ openStudentsBoardedPopup: false })}
                >
                    <div style={{ height: "70vh", }}>
                        <Table className="schoolDashboardTable"
                            columns={this.studentBoardedColumns}
                            dataSource={this.schoolDashboardStore.studentListData}
                            pagination={false}
                            scroll={{ y: 360 }}
                        />
                    </div>
                </Modal>

                <Modal className="windowModal"
                    open={this.state.openStudentsoffBoardedPopup}
                    footer={null}
                    closable={false}
                    width={1100}
                    maskClosable={true}
                    onCancel={() => this.setState({ openStudentsoffBoardedPopup: false })}
                >
                    <div style={{ height: "70vh", }}>
                        <Table className="schoolDashboardTable"
                            columns={this.studentOffBoardedColumns}
                            dataSource={this.schoolDashboardStore.studentListData}
                            pagination={false}
                            scroll={{ y: 360 }}
                        />

                    </div>
                </Modal>
            </>
        );
    }

}

SchoolDashboard.contextType = StoreContext;
export default observer(withRouter(SchoolDashboard));